import { Category } from '@@types'
import { generatePath } from 'react-router'

import { URL_PAGE_CATALOG_2ND_LVL } from '@shared/contants'
import { LocalizedLink as Link } from '@shared/lib/locale'

import styles from './styles.module.scss'

interface CategoryChildrensProps {
  items: Category[];
  parentSlug: string;
}

export default function CategoryChildrens (props: CategoryChildrensProps) {
  const { items, parentSlug } = props

  const makePath = (slug: string) => generatePath(URL_PAGE_CATALOG_2ND_LVL, {
    categoryChildrenSlug: slug,
    categorySlug: parentSlug,
  })

  return (
    <div className={styles.root}>
      {items &&
        items.map((item) => {
          if (!item) return null

          return (
            <Link
              className={styles['root__link']}
              to={makePath(item?.slug as string)}
              key={item?.id}
            >
              {item?.name}
            </Link>
          )
        })}
    </div>
  )
}
